export { default } from './EditHistory';
